import { staticText } from 'utils/staticText';

export const personalLoanCalculatorTranslations = staticText({
  loan_details: {
    _: 'Loan details',
    zh: '貸款詳情',
  },
  loan_amount: {
    _: 'Loan amount',
    zh: '貸款金額',
  },
  currency_note_sgd: {
    _: 'All dollar values are in Singapore Dollars (S$).',
    zh: '所有金額均以新加坡元（SGD$）計算。',
  },
  currency_note_hkd: {
    _: 'All dollar values are in Hong Kong Dollars (HK$).',
    zh: '所有金額均以港元（HK$）計算。',
  },
  currency_note_ntd: {
    _: 'All dollar values are in New Taiwan Dollars (NT$).',
    zh: '所有金額均以新台幣（NT$）計算。',
  },
  repayment_period: {
    _: 'Repayment period',
    zh: '還款期',
  },
  annual_interest_rate: {
    _: 'Annual interest rate (% p.a.)',
    zh: '年利率 (%)',
  },
  processing_fee: {
    _: 'Processing fee',
    zh: '手續費',
  },
  start_date: {
    _: 'Start date',
    zh: '開始日期',
  },
  calculate: {
    _: 'Calculate',
    zh: '計算',
  },
  loan_estimate: {
    _: 'Loan Estimate',
    zh: '貸款估算結果',
  },
  monthly_repayment: {
    _: 'Monthly repayment',
    zh: '每月供款',
  },
  total_repayment: {
    _: 'Total repayment',
    zh: '總還款金額',
  },
  effective_interest_rate: {
    _: 'EIR (% p.a.)',
    zh: '實際年利率 (%)',
  },
  apr: {
    _: 'APR (% p.a.)',
    zh: '最低實際年利率 (%)',
  },
  principal: {
    _: 'Principal',
    zh: '本金',
  },
  interest: {
    _: 'Interest',
    zh: '利息',
  },
  principal_balance: {
    _: 'Principal Balance',
    zh: '剩餘本金',
  },
  payment_schedule: {
    _: 'Payment Schedule',
    zh: '還款時間表',
  },
  show_all: {
    _: 'Show All',
    zh: '顯示全部',
  },
  interest_rate_error: {
    _: 'Interest rate must be between 0 and 100',
    zh: '利率必須介於 0 至 100 之間',
  },
  month: {
    _: 'Month',
    zh: '月份',
  },
  month_singular: {
    _: 'month',
    zh: '個月',
  },
  months: {
    _: 'months',
    zh: '個月',
  },
  year: {
    _: 'year',
    zh: '年',
  },
  years: {
    _: 'years',
    zh: '年',
  },
});
